import styled from 'styled-components'

// Product List Header Styles
export const ProductListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
  }
`

export const SearchContainer = styled.div`
  position: relative;
  flex: 1;
  max-width: 500px;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`

export const SearchIcon = styled.div`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.875rem 1rem 0.875rem 3rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 1rem;
  color: #111827;
  background: white;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #02b0bb;
    box-shadow: 0 0 0 3px rgba(2, 176, 187, 0.15);
  }

  &::placeholder {
    color: #9ca3af;
  }
`

export const CartIconContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: #02b0bb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: #018a94;
    transform: scale(1.05);
  }

  svg {
    color: white;
    width: 24px;
    height: 24px;
  }
`

export const CartBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  background: #ef4444;
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-end;
  }
`

export const FilterContainer = styled.div`
  position: relative;
`

export const FilterButton = styled.button<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 48px;
  padding: 0 1rem;
  background: ${(props) => (props.isActive ? '#02b0bb' : 'white')};
  color: ${(props) => (props.isActive ? 'white' : '#374151')};
  border: 2px solid ${(props) => (props.isActive ? '#02b0bb' : '#e5e7eb')};
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  font-weight: 500;
  flex-shrink: 0;

  &:hover {
    border-color: #02b0bb;
    background: ${(props) => (props.isActive ? '#018a94' : '#f0fdff')};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

export const FilterDropdown = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 100;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  transform: ${(props) => (props.isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  transition: all 0.2s ease;
  overflow: hidden;
`

export const FilterDropdownHeader = styled.div`
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 600;
  color: #111827;
  font-size: 0.875rem;
`

export const FilterOption = styled.button<{ isSelected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.875rem 1rem;
  background: ${(props) => (props.isSelected ? '#f0fdff' : 'transparent')};
  border: none;
  color: ${(props) => (props.isSelected ? '#02b0bb' : '#374151')};
  font-size: 0.875rem;
  font-weight: ${(props) => (props.isSelected ? '600' : '400')};
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;

  &:hover {
    background: #f9fafb;
  }

  &:last-child {
    border-radius: 0 0 12px 12px;
  }
`

export const FilterCheckIcon = styled.span<{ isVisible: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props) => (props.isVisible ? '#02b0bb' : '#e5e7eb')};
  color: white;
  font-size: 0.75rem;
  transition: all 0.15s ease;

  svg {
    width: 12px;
    height: 12px;
    opacity: ${(props) => (props.isVisible ? 1 : 0)};
  }
`

export const FilterBadge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background: white;
  color: #02b0bb;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 50%;
`

export const ProductListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

// Product List Styles
export const ProductGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`

export const ProductCard = styled.div<{ isComingSoon?: boolean }>`
  background: white;
  border-radius: 12px;
  display: flex;
  gap: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid ${(props) => (props.isComingSoon ? '#02b0bb' : '#e5e7eb')};
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  padding: 1.5rem;
  align-items: center;
  opacity: ${(props) => (props.isComingSoon ? 0.7 : 1)};
  position: relative;

  &:hover {
    transform: ${(props) => (props.isComingSoon ? 'none' : 'translateY(-2px)')};
    box-shadow: ${(props) => (props.isComingSoon ? '0 2px 8px rgba(0, 0, 0, 0.1)' : '0 4px 12px rgba(0, 0, 0, 0.15)')};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
  }
`

export const ComingSoonBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #02b0bb 0%, #018a94 100%);
  color: white;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(2, 176, 187, 0.4);
`

export const ComingSoonButton = styled.button`
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: not-allowed;
  width: fit-content;
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`

export const ProductImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  background: #f3f4f6;
  border-radius: 8px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
  }
`

export const ProductInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: space-between;
  width: 85%;
`

export const ProductName = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
  line-height: 1.4;
`

export const ProductPrice = styled.p`
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
`

export const BuyButton = styled.button`
  background: #02b0bb;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  width: fit-content;
  align-self: flex-start;

  &:hover {
    background: #02b0bb;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

// Cart List Styles
export const CartContainer = styled.div`
  width: 100%;
  padding: 1rem;

  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`

export const CartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
`

export const CartTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #111827;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`

export const CartItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  overflow: hidden;
`

export const CartItemCard = styled.div`
  display: grid;
  grid-template-columns: 3fr 2.5fr 1.5fr 1.5fr;
  gap: 1rem;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  align-items: center;

  &:last-child {
    border-bottom: none;
  }

  &:first-child {
    background: #f9fafb;
    font-weight: 600;
    padding: 1rem 1.5rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding: 1rem;
  }
`

export const CartItemImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
  background: #f3f4f6;
  margin-right: 1rem;

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
  }
`

export const CartItemInfo = styled.div`
  display: contents;
`

export const CartItemName = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: #111827;
  display: flex;
  align-items: center;

  strong {
    margin-right: 0.5rem;
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const CartItemPrice = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`

export const CartItemQuantity = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`

export const QuantityButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: white;
  color: #374151;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
  }

  &:active {
    transform: scale(0.95);
  }
`

export const QuantityValue = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  min-width: 30px;
  text-align: center;
`

export const RemoveButton = styled.button`
  background: transparent;
  color: #dc2626;
  border-radius: 50%;
  border: none;
  width: 32px;
  height: 32px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`

export const EmptyCart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  width: 100%;

  p {
    font-size: 1.25rem;
    color: #6b7280;
    margin-bottom: 2rem;
  }
`

export const AddProductsButton = styled.button`
  background: #02b0bb;
  color: white;
  border: 1px solid #02b0bb;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #fff;
    color: #02b0bb;
    border: 1px solid #02b0bb;
  }
`

export const CartSummary = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;
  width: 100%;
`

export const CouponContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const CouponInput = styled.input`
  flex: 1;
  height: 44px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0 0.875rem;
  font-size: 0.95rem;
  color: #111827;

  &:focus {
    outline: none;
    border-color: #02b0bb;
    box-shadow: 0 0 0 3px rgba(2, 176, 187, 0.1);
  }
`

export const CouponButton = styled.button`
  background: #02b0bb;
  color: white;
  border: 1px solid #02b0bb;
  border-radius: 8px;
  height: 44px;
  padding: 0 1rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #018a94;
    border-color: #018a94;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`

export const SummaryLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`

export const SummaryLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TotalLabel = styled.span`
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
`

export const TotalValue = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin-left: 1rem;
`

export const CheckoutButton = styled.button`
  background: #02b0bb;
  color: white;
  border: 1px solid #02b0bb;
  border-radius: 8px;
  padding: 1rem 2rem;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  width: 100%;

  &:hover {
    background: #fff;
    color: #02b0bb;
    border: 1px solid #02b0bb;
  }

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`

// Shared Styles
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 1.125rem;
  color: #6b7280;
`

export const ErrorContainer = styled.div`
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  padding: 1rem;
  color: #991b1b;
  text-align: center;
  margin: 2rem;
`

export const SummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

// Checkout Styles
export const FormsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`

export const AddressContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 1.5rem 0;
  }
`

export const AddressForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const AddressLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  display: block;
`

export const AddressInput = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  color: #111827;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #02b0bb;
    box-shadow: 0 0 0 3px rgba(2, 176, 187, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`

// Payment Styles
export const PaymentContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 1.5rem 0;
  }
`

export const PaymentSelector = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const PaymentOption = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem;
  border: 2px solid ${(props) => (props.selected ? '#02b0bb' : '#e5e7eb')};
  border-radius: 12px;
  background: ${(props) => (props.selected ? '#f0fdff' : 'white')};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #02b0bb;
    background: #f0fdff;
  }
`

export const PaymentMethodIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f3f4f6;
  color: #02b0bb;
  flex-shrink: 0;
`

export const PaymentMethodInfo = styled.div`
  flex: 1;

  h3 {
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.25rem 0;
  }

  p {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
  }
`

export const PaymentAmount = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  border: none;
  color: #02b0bb;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem;
  transition: all 0.2s;

  &:hover {
    color: #018a94;
  }
`

export const SelectedMethodHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;

  div {
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
  }
`

// Warning Card Styles
export const WarningCard = styled.div`
  background: #fef3c7;
  border: 2px solid #fbbf24;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 2px 8px rgba(251, 191, 36, 0.2);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const WarningIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fbbf24;
  color: white;
  flex-shrink: 0;
  font-size: 1.5rem;
  font-weight: bold;
`

export const WarningContent = styled.div`
  flex: 1;

  h3 {
    font-size: 1.125rem;
    font-weight: 700;
    color: #92400e;
    margin: 0 0 0.5rem 0;
  }

  p {
    font-size: 0.875rem;
    color: #78350f;
    margin: 0;
    line-height: 1.5;
  }
`

export const WarningAmount = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: #92400e;
  margin-right: 1rem;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-top: 0.5rem;
  }
`

export const PayAssociationButton = styled.button`
  background: #fbbf24;
  color: #78350f;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #f59e0b;
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`
